import validatorEnum from './validatorEnum';

/**
 *
 * @param {String} value // textField input
 * @param {Array} validators // list of validator
 */

export default function mapValidators(value, validators = [], ...reset) {
    const confirmPasswordNotMatchPassword = reset[0]?.confirmPasswordNotMatchPassword;

    let errorMessages = [];
    for (let i of validators) {
        const messages =
            i === 'checkConfirmPassword' ? validatorEnum[i](confirmPasswordNotMatchPassword) : validatorEnum[i](value);

        if (i === 'isRequired' && messages.length > 0) {
            errorMessages = errorMessages.concat(messages);
            break;
        }

        errorMessages = errorMessages.concat(messages);
    }
    // console.log('mapValidators', errorMessages);
    return errorMessages;
}
